(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["envio-gratis"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mcShippingBarInit3) return;
    window.__mcShippingBarInit3 = true;
    window.__mcShippingBarInit = true;

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
        return Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
    function updateBar(bar, cartTotal) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      var gift = parseInt(bar.dataset.giftThreshold || '0', 10);
      var giftEnabled = gift > threshold;
      var msg, progress;
      if (cartTotal < threshold) {
        msg = bar.dataset.messageProgress.replace('[amount]', formatMoney(threshold - cartTotal));
      } else if (giftEnabled && cartTotal < gift) {
        msg = bar.dataset.messageGiftProgress.replace('[amount]', formatMoney(gift - cartTotal));
      } else if (giftEnabled) {
        msg = bar.dataset.messageGiftSuccess;
      } else {
        msg = bar.dataset.messageSuccess;
      }
      if (giftEnabled) {
        progress = cartTotal < threshold
          ? (cartTotal / threshold) * 50
          : 50 + ((cartTotal - threshold) / (gift - threshold)) * 50;
      } else {
        progress = (cartTotal / threshold) * 100;
      }
      progress = Math.max(0, Math.min(progress, 100));
      var msgEl = bar.querySelector('[data-mc-sb-message]');
      var fillEl = bar.querySelector('[data-mc-sb-fill]');
      var shipStep = bar.querySelector('[data-mc-sb-step="shipping"]');
      var giftStep = bar.querySelector('[data-mc-sb-step="gift"]');
      if (msgEl) msgEl.textContent = msg;
      if (fillEl) fillEl.style.width = progress + '%';
      if (shipStep) shipStep.classList.toggle('is-reached', cartTotal >= threshold);
      if (giftStep) giftStep.classList.toggle('is-reached', giftEnabled && cartTotal >= gift);
    }
    function refreshAll() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-mc-shipping-bar]').forEach(function (bar) {
            updateBar(bar, cart.total_price);
          });
        }).catch(function () {});
    }
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0];
      if (url && typeof url === 'object' && url.url) url = url.url;
      var isMut = typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url);
      var res = origFetch.apply(this, args);
      if (isMut) res.then(function () { setTimeout(refreshAll, 50); }).catch(function () {});
      return res;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          setTimeout(refreshAll, 50);
        }
      });
      return origOpen.apply(this, arguments);
    };
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, refreshAll);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
